





































































import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  ref
} from "@vue/composition-api";

import { Context } from "@/tools/msa/utils/machine";
import { copyToClipboard } from "@/tools/msa/utils/clipboard";
import ExportedDocument from "@/tools/msa/components/export/ExportedDocument.vue";
import ExportedTable from "@/tools/msa/components/export/ExportedTable.vue";
import BaseTab from "@/components/BaseTab.vue";

interface Props {
  context: Context;
}

export default defineComponent<Props>({
  name: "ExportView",
  components: { BaseTab, ExportedTable, ExportedDocument },
  props: {
    context: { type: Object, required: true }
  },
  setup: function(props: Props) {
    const tab = ref<number>(1);

    const element = ref<HTMLElement | null>(null);

    const isCopying = ref<boolean>(false);

    onMounted(() => {
      nextTick(() => {
        if (element.value) {
          element.value
            .querySelectorAll(".page-break")
            .forEach(page =>
              page.setAttribute(
                "style",
                'page-break-before: always; clear: both; content: " "; display: block; margin: 0;'
              )
            );
        }
      });
    });

    const documents = computed(() =>
      props.context.session!.documents.filter(
        document =>
          document.chiefComplaint.length > 0 ||
          document.diagnoses.length > 0 ||
          document.assessments.length > 0 ||
          document.medications.length > 0 ||
          document.plans.length > 0
      )
    );

    const copy = () => {
      isCopying.value = true;

      nextTick(() => {
        copyToClipboard(element.value);
        isCopying.value = false;
      });
    };

    return {
      tab,
      documents,
      element,
      isCopying,
      copy
    };
  }
});
